import MyContext from '@/shared/contexts/AppContext';
import {
  GetMeusPaineisGerenciais,
  type ReadPainelGerencialMeuDto,
} from '@/modules/system/painel-gerencial/painel-gerencial.service';
import type { PainelGerencialMenuItem } from '@/shared/navigation/navigation-menu.config';
import { useContext, useEffect, useState } from 'react';

export function useMeusPaineisGerenciais(): PainelGerencialMenuItem[] {
  const context = useContext(MyContext);
  const temPainelGerencial = context?.temPainelGerencial ?? false;
  const [paineis, setPaineis] = useState<PainelGerencialMenuItem[]>([]);

  useEffect(() => {
    if (!temPainelGerencial) {
      setPaineis([]);
      return;
    }

    let cancelled = false;
    GetMeusPaineisGerenciais()
      .then((lista: ReadPainelGerencialMeuDto[]) => {
        if (cancelled) return;
        setPaineis(
          lista.map((p) => ({
            id: p.id,
            nome: p.nome,
          })),
        );
      })
      .catch(() => {
        if (!cancelled) setPaineis([]);
      });

    return () => {
      cancelled = true;
    };
  }, [temPainelGerencial]);

  return paineis;
}
